var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.select)?_c('Capital'):(_vm.$store.state.flag)?_c('Flag'):_c('Result')],1)}
var staticRenderFns = []

export { render, staticRenderFns }